import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style21({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="codeName"
      activeItemIconName="translate"
      onClick={onClick}
    />
  );
}
